import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';
import { HistoryDetailsProps } from '../api/response';

export const useHistoryDetailsQuery = (bookingId: string) => {
  const axios = useAxios();

  const handleFetch = () => axios.get<AxiosResponse<HistoryDetailsProps>>(`${ApiRoutes.historyDetails}/${bookingId}`);

  return useQuery(['history-details', bookingId], handleFetch, {
    select: res => {
      return res.data.data;
    },
    keepPreviousData: true,
    cacheTime: USE_QUERY_CONSTANTS.cacheMs,
    refetchOnWindowFocus: USE_QUERY_CONSTANTS.refetchOnWindowFocus,
    retry: USE_QUERY_CONSTANTS.retry,
  });
};
